/**
 * Returns the creation date of a Mongo document given its ObjectId
 * @param {string} objectId
 * @returns number
 */
const getCreationDate = (objectId) => {
  const date = new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
  return date.getTime();
};

export default getCreationDate;
